import React from "react";

import PageLayout from "@layout/PageLayout";

import GettingInvolvedBody from "./GettingInvolvedBody";
import { transformGetInvolvedPageData } from "./transformGetInvolvedPageData";

import { bulkRenderRichText } from "@utils/prismic-render-utils";
import { renderRichText } from "../../utils/prismic-render-utils";

const renderRichTextFields = data => {
	let richTextData = {
		...bulkRenderRichText(data, ["staffContact", "contactLinks"]),
		staffContact: data.staffContact.map(contact => ({
			...contact,
			description: renderRichText(contact.description),
		})),
	};
	return { ...data, ...richTextData };
};

const GettingInvolved = props => {
	const data = props.previewData
		? renderRichTextFields(transformGetInvolvedPageData(props.previewData))
		: renderRichTextFields(props.pageContext.data);

	return (
		<PageLayout
			{...props}
			data={data}
			tocQuery="h2,h3"
			pageTitle="Getting Involved"
			renderPage={pageProps => <GettingInvolvedBody {...pageProps} />}
		/>
	);
};

export default GettingInvolved;
